import * as React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router';
import { Redirect } from 'react-router-dom';

import CampaignForm from './CampaignForm';
import CampaignList from './CampaignList';
import { userCanAccessCampaignsUi } from './campaignStorage';
import DeliveryMethodEdit from './DeliveryMethodEdit';
import NotificationEdit from './NotificationEdit';
import NotificationList from './NotificationList';
import RulesetList from './RulesetList';
import RulesetEdit from './RulesetEdit';
import NotificationStringList from './NotificationStringList';
import NotificationStringEdit from './NotificationStringEdit';
import NotificationStringCreate from './NotificationStringCreate';
import BlacklistList from './blacklists/BlacklistList';
import { AIChangeDetailPage, AIChangesPage, AIProposalReviewPage } from './aiChanges/AIChangesPages';
import { BlockListsPage, BlocksPage, LanguagePoliciesPage, ThemesPage } from './content/ContentPages';

const TripPage = (props: any) => {
    let { path } = useRouteMatch();
    const [lastTabSelected, setLastTabSelected] = React.useState();
    const [recordListFilters, setRecordListFilters] = React.useState({ role: [], tour: null, delivery_method: null, event: null });
    const [recordListQuery, setRecordListQuery] = React.useState(null);

    return (
        <Switch>
            <Route path={`${path}/strings/create`}>
                <NotificationStringCreate {...props} />
            </Route>
            <Route path={`${path}/strings/:id`}>
                <NotificationStringEdit {...props} />
            </Route>
            <Route path={`${path}/strings/`}>
                <NotificationStringList {...props} />
            </Route>
            <Route path={`${path}/blacklists`}>
                <BlacklistList {...props} />
            </Route>
            {/* AI changes (metaplan A10; D-menu): the review pages MCP tool output links to. */}
            <Route path={`${path}/ai_changes/proposals/:id`}>
                <AIProposalReviewPage />
            </Route>
            <Route path={`${path}/ai_changes/:id`}>
                <AIChangeDetailPage />
            </Route>
            <Route path={`${path}/ai_changes`}>
                <AIChangesPage />
            </Route>
            {/* Read-only content views (metaplan A10): the models' get_dashboard_link() paths, which used to
                fall into /:id/:delivery_method_id below. */}
            <Route path={`${path}/blocks/:id`}>
                <BlocksPage />
            </Route>
            <Route path={`${path}/blocks`}>
                <BlocksPage />
            </Route>
            <Route path={`${path}/block_lists/:id`}>
                <BlockListsPage />
            </Route>
            <Route path={`${path}/block_lists`}>
                <BlockListsPage />
            </Route>
            <Route path={`${path}/themes/:id`}>
                <ThemesPage />
            </Route>
            <Route path={`${path}/themes`}>
                <ThemesPage />
            </Route>
            <Route path={`${path}/language_policies/:id`}>
                <LanguagePoliciesPage />
            </Route>
            <Route path={`${path}/language_policies`}>
                <LanguagePoliciesPage />
            </Route>
            <Route path={`${path}/language_aliases/:id`}>
                <LanguagePoliciesPage aliases />
            </Route>
            <Route path={`${path}/language_aliases`}>
                <LanguagePoliciesPage aliases />
            </Route>
            <Route path={`${path}/rulesets/:id`}>
                <RulesetEdit {...props} />
            </Route>
            <Route path={`${path}/rulesets`}>
                <RulesetList {...props} />
            </Route>
            <Route
                path={`${path}/campaigns/create`}
                exact
                render={() =>
                    userCanAccessCampaignsUi() ? <CampaignForm isNew /> : <Redirect to={`${path}`} />
                }
            />
            <Route
                path={`${path}/campaigns/:campaignId`}
                exact
                render={() => (userCanAccessCampaignsUi() ? <CampaignForm /> : <Redirect to={`${path}`} />)}
            />
            <Route
                path={`${path}/campaigns`}
                exact
                render={() => (userCanAccessCampaignsUi() ? <CampaignList /> : <Redirect to={`${path}`} />)}
            />
            <Route path={`${path}/create`}>
                <NotificationEdit {...props} />
            </Route>
            <Route path={`${path}/:id/:delivery_method_id`}>
                <DeliveryMethodEdit {...props} />
            </Route>
            <Route path={`${path}/:id`}>
                <NotificationEdit {...props} lastTabSelected={lastTabSelected} />
            </Route>
            <Route exact path={path}>
                <NotificationList setRecordListQuery={setRecordListQuery} recordListQuery={recordListQuery} recordListFilters={recordListFilters} setRecordListFilters={setRecordListFilters} lastTabSelected={lastTabSelected} setLastTabSelected={setLastTabSelected} {...props} />
            </Route>
        </Switch>
    );
};

export default TripPage;
